(() => {
  // SOLUTIONPOOL: single desktop hover controller; native Dawn click/mobile retained.
  if (window.__spMenuController) return;
  window.__spMenuController = true;
  const desktop = () => matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
  const menus = () => [...document.querySelectorAll('.header__inline-menu header-menu')];
  const timers = new WeakMap();
  const clear = menu => { clearTimeout(timers.get(menu)); timers.delete(menu); };
  function close(menu) {
    clear(menu);
    const details = menu.querySelector(':scope > details');
    if (!details) return;
    details.open = false;
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
  }
  function open(menu) {
    if (!desktop()) return;
    clear(menu);
    menus().forEach(other => { if (other !== menu) close(other); });
    const details = menu.querySelector(':scope > details');
    if (!details) return;
    details.open = true;
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'true');
  }
  function bind() {
    menus().forEach(menu => {
      if (menu.dataset.spHoverBound === 'v3') return;
      menu.dataset.spHoverBound = 'v3';
      // Non-bubbling enter/leave avoids child-to-child pointerout races.
      menu.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') open(menu); });
      menu.addEventListener('pointerleave', e => {
        if (!desktop() || e.pointerType !== 'mouse') return;
        clear(menu);
        timers.set(menu, setTimeout(() => {
          if (!menu.matches(':hover') && !menu.contains(document.activeElement)) close(menu);
        }, 320));
      });
      menu.addEventListener('focusin', () => clear(menu));
    });
  }
  document.addEventListener('pointerover', e => {
    if (!desktop() || e.pointerType !== 'mouse') return;
    const menu = e.target instanceof Element ? e.target.closest('.header__inline-menu header-menu') : null;
    if (menu) { bind(); open(menu); }
  }, true);
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const menu = e.target instanceof Element ? e.target.closest('.header__inline-menu header-menu') : null;
    if (menu) { close(menu); menu.querySelector(':scope > details > summary')?.focus(); }
  });
  document.addEventListener('click', e => {
    if (e.target instanceof Element && e.target.closest('.header__inline-menu header-menu')) return;
    menus().forEach(close);
  });
  document.addEventListener('shopify:section:load', bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, {once:true});
  else bind();
})();
/* SOLUTIONPOOL desktop page-blur layer; menu stays crisp and clickable. */
(() => {
  if (window.__spPageBlurInit) return;
  window.__spPageBlurInit = true;
  function update() {
    const desktop = matchMedia('(min-width: 990px)').matches;
    const open = desktop && !!document.querySelector('.header__inline-menu details.mega-menu[open]');
    document.body.classList.toggle('sp-menu-page-blur-open', open);
  }
  function init() {
    if (!document.getElementById('sp-menu-page-blur')) {
      const overlay = document.createElement('div');
      overlay.id = 'sp-menu-page-blur';
      overlay.setAttribute('aria-hidden', 'true');
      document.body.appendChild(overlay);
    }
    const header = document.querySelector('.header__inline-menu');
    if (header) new MutationObserver(update).observe(header, {subtree:true, attributes:true, attributeFilter:['open']});
    update();
  }
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
